import React from 'react';
import Column from '../Column';
import styles from './index.module.css';

const OneColumn: Component = ({ className = '', layout, components }) => {
  const { columns, background } = layout;

  return (
    <Column
      column={columns[0]}
      className={`${styles.column} ${background && styles.gray}`}
      components={components}
    />
  );
};

export default OneColumn;
